import { Button, ImprTooltip } from '@imprivata-cloud/components';
import { useTranslation } from 'react-i18next';
import RevokeConsent from '../../assets/icons/revoke-consent.svg?react';
import TrashIcon from '../../assets/icons/trash.svg?react';
import EditIcon from '../../assets/icons/edit.svg?react';
import './AuthenticatorActionItems.less';
import { FactorType } from '@/api/types';
import { Tag } from '@imprivata-cloud/design-system';

const nonRemovableFactors = new Set<FactorType>([FactorType.PASSWORD, FactorType.OTP]);

type AuthenticatorTableRecordProps = {
  key: string;
  factorType: FactorType;
  assuranceType?: string;
  onRemove: () => void;
  onEdit?: () => void;
  onRevokeConsent?: () => void;
  epcs?: boolean;
  onEpcsSetup?: () => void;
};

const AuthenticatorActionItems = (prop: AuthenticatorTableRecordProps) => {
  const { t } = useTranslation();
  return (
    <div className="auth-action-items">
      {prop.epcs && (
        <Tag className="m-2" text={t('self-service.authenticator-list.epcs')} color="swagger" />
      )}
      {!!prop.onEpcsSetup && (
        <Button
          type="link"
          className="epcs-setup-btn"
          label={t('self-service.authenticator-list.use-for-epcs')}
          onClick={prop.onEpcsSetup}
        />
      )}
      {!!prop.onRevokeConsent && prop.factorType === FactorType.FACE && (
        <ImprTooltip title={t('self-service.authenticator-list.revoke-consent-tooltip')}>
          <Button
            type="text"
            className="revoke-consent-btn"
            icon={<RevokeConsent />}
            onClick={prop?.onRevokeConsent}
          />
        </ImprTooltip>
      )}
      {prop.factorType === FactorType.PASSWORD && prop?.onEdit && (
        <ImprTooltip title={t('self-service.authenticator-list.edit-tooltip')}>
          <Button
            type="text"
            className="edit-btn"
            icon={<EditIcon />}
            onClick={prop?.onEdit}
            aria-label="Edit"
          />
        </ImprTooltip>
      )}
      {!nonRemovableFactors.has(prop.factorType) && (
        <ImprTooltip title={t('self-service.authenticator-list.remove-tooltip')}>
          <Button
            type="text"
            className="remove-btn"
            icon={<TrashIcon />}
            onClick={prop?.onRemove}
            aria-label="Remove"
          />
        </ImprTooltip>
      )}
    </div>
  );
};

export default AuthenticatorActionItems;
